/* =========================================================
   Perla Parfemi — theme.js
   Cart drawer, varijante, količina, akordeoni, filteri, toast
   ========================================================= */
(function () {
  'use strict';

  var money = function (cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.themeMoneyFormat);
    }
    return (cents / 100).toLocaleString('sr-RS', { maximumFractionDigits: 0 }) + ' RSD';
  };

  /* ---------------- Toast ---------------- */
  var toastEl = null;
  var toastTimer = null;
  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    requestAnimationFrame(function () {
      toastEl.classList.add('is-visible');
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2600);
  }

  /* ---------------- Cart drawer ---------------- */
  function openDrawer() {
    document.body.classList.add('drawer-open');
    var close = document.querySelector('[data-drawer-close]');
    if (close) close.focus();
  }

  function closeDrawer() {
    document.body.classList.remove('drawer-open');
  }

  function refreshDrawer() {
    return fetch(window.Shopify.routes.root + '?section_id=cart-drawer', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-drawer-root]');
        var current = document.querySelector('[data-drawer-root]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        return fetch(window.Shopify.routes.root + 'cart.js');
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-hidden', cart.item_count === 0);
        });
        return cart;
      })
      .catch(function () { /* tiho */ });
  }

  function addToCart(variantId, quantity, button, thenCheckout) {
    var original = button ? button.innerHTML : null;
    if (button) {
      button.disabled = true;
      button.innerHTML = '<span class="spinner"></span>';
    }
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw e; });
        return res.json();
      })
      .then(function (data) {
        if (thenCheckout) {
          window.location.href = window.Shopify.routes.root + 'checkout';
          return;
        }
        if (button) {
          button.innerHTML = window.themeStrings.added;
          setTimeout(function () {
            button.innerHTML = original;
            button.disabled = false;
          }, 1800);
        }
        toast(window.themeStrings.addedToast + (data.title ? ' — ' + data.title : ''));
        return refreshDrawer().then(function () { openDrawer(); });
      })
      .catch(function (err) {
        if (button) {
          button.innerHTML = original;
          button.disabled = false;
        }
        toast((err && err.description) || window.themeStrings.error);
      });
  }

  function changeLine(key, quantity) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.body.getAttribute('data-template') === 'cart') {
          window.location.reload();
          return;
        }
        return refreshDrawer();
      });
  }

  /* ---------------- Delegated events ---------------- */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) {
      e.preventDefault();
      refreshDrawer();
      openDrawer();
      return;
    }

    if (e.target.closest('[data-drawer-close]') || e.target.closest('.drawer-overlay')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var add = e.target.closest('[data-add-to-cart]') || e.target.closest('[data-buy-now]');
    if (add) {
      e.preventDefault();
      var buyNow = add.hasAttribute('data-buy-now');
      var form = add.closest('form') || document.querySelector('[data-product-form]');
      var id = add.getAttribute('data-variant-id');
      var qtyInput = form ? form.querySelector('[name="quantity"]') : null;
      if (!id && form) {
        var idInput = form.querySelector('[name="id"]');
        if (idInput) id = idInput.value;
      }
      if (id) addToCart(id, qtyInput ? parseInt(qtyInput.value, 10) : 1, add, buyNow);
      return;
    }

    var lineBtn = e.target.closest('[data-line-change]');
    if (lineBtn) {
      e.preventDefault();
      changeLine(lineBtn.getAttribute('data-line-key'), parseInt(lineBtn.getAttribute('data-line-change'), 10));
      return;
    }

    var step = e.target.closest('[data-qty-step]');
    if (step) {
      e.preventDefault();
      var input = step.parentElement.querySelector('input');
      var next = parseInt(input.value, 10) + parseInt(step.getAttribute('data-qty-step'), 10);
      input.value = Math.max(1, isNaN(next) ? 1 : next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) {
      e.preventDefault();
      var wrap = thumb.closest('[data-gallery]');
      var main = wrap.querySelector('[data-gallery-main]');
      main.src = thumb.getAttribute('data-full');
      main.srcset = '';
      main.alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : main.alt;
      wrap.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('drawer-open')) closeDrawer();
  });

  /* ---------------- Variant picker ---------------- */
  function initVariantPicker(root) {
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var stockEl = root.querySelector('[data-stock]');
    var submit = root.querySelector('[data-add-to-cart]');
    var buyNow = root.querySelector('[data-buy-now]');
    var totalEl = root.querySelector('[data-line-total]');
    var qtyInput = root.querySelector('[name="quantity"]');

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option-index]'), function (group) {
        var active = group.querySelector('.opt__value.is-active');
        return active ? active.getAttribute('data-value') : null;
      });
    }

    function match() {
      var chosen = selected();
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
    }

    function update() {
      var v = match();
      if (!v) {
        if (submit) { submit.disabled = true; submit.textContent = window.themeStrings.unavailable; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (submit) submit.setAttribute('data-variant-id', v.id);
      if (buyNow) {
        buyNow.setAttribute('data-variant-id', v.id);
        buyNow.disabled = !v.available;
      }
      if (priceEl) priceEl.innerHTML = money(v.price);
      document.querySelectorAll('[data-sticky-price]').forEach(function (el) {
        el.innerHTML = money(v.price);
      });
      document.querySelectorAll('.sticky-cta [data-buy-now]').forEach(function (el) {
        el.setAttribute('data-variant-id', v.id);
        el.disabled = !v.available;
      });
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.innerHTML = '<s>' + money(v.compare_at_price) + '</s>';
          compareEl.classList.remove('is-hidden');
        } else {
          compareEl.classList.add('is-hidden');
        }
      }
      if (stockEl) stockEl.textContent = v.available ? window.themeStrings.inStock : window.themeStrings.soldOut;
      if (submit) {
        submit.disabled = !v.available;
        submit.textContent = v.available ? window.themeStrings.addToCart : window.themeStrings.soldOut;
      }
      updateTotal(v);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    function updateTotal(v) {
      if (!totalEl) return;
      var variant = v || match();
      if (!variant) return;
      var q = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      totalEl.innerHTML = window.themeStrings.total + ' ' + money(variant.price * q);
    }

    root.querySelectorAll('.opt__value').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var group = btn.closest('[data-option-index]');
        group.querySelectorAll('.opt__value').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        update();
      });
    });

    if (qtyInput) qtyInput.addEventListener('change', function () { updateTotal(); });
    updateTotal();
  }

  /* ---------------- Collection filters (client side) ---------------- */
  function initCollectionFilters() {
    var root = document.querySelector('[data-collection-filters]');
    if (!root) return;
    var grid = document.querySelector('[data-product-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-card]'));
    var search = root.querySelector('[data-filter-search]');
    var sort = root.querySelector('[data-filter-sort]');
    var countEl = document.querySelector('[data-result-count]');
    var empty = document.querySelector('[data-empty-state]');
    var priceChips = Array.prototype.slice.call(root.querySelectorAll('[data-filter-price]'));
    var stockChip = root.querySelector('[data-filter-stock]');
    var clearChip = root.querySelector('[data-filter-clear]');

    function apply() {
      var q = (search && search.value || '').trim().toLowerCase();
      var activeChip = priceChips.find(function (c) { return c.classList.contains('is-active'); });
      var range = activeChip ? activeChip.getAttribute('data-filter-price') : 'all';
      var stockOnly = stockChip && stockChip.classList.contains('is-active');
      var visible = 0;

      cards.forEach(function (card) {
        var title = (card.getAttribute('data-title') || '').toLowerCase();
        var price = parseInt(card.getAttribute('data-price'), 10) || 0;
        var available = card.getAttribute('data-available') === 'true';
        var ok = true;
        if (q && title.indexOf(q) === -1) ok = false;
        if (range === 'low' && price >= 300000) ok = false;
        if (range === 'mid' && (price < 300000 || price > 600000)) ok = false;
        if (range === 'high' && price <= 600000) ok = false;
        if (stockOnly && !available) ok = false;
        card.classList.toggle('is-hidden', !ok);
        if (ok) visible++;
      });

      if (countEl) {
        countEl.textContent = visible + ' ' + (visible === 1
          ? window.themeStrings.productOne
          : (visible >= 2 && visible <= 4 ? window.themeStrings.productFew : window.themeStrings.productMany));
      }
      if (empty) empty.classList.toggle('is-hidden', visible !== 0);
      if (clearChip) {
        var dirty = !!q || range !== 'all' || !!stockOnly || (sort && sort.value !== 'featured');
        clearChip.classList.toggle('is-hidden', !dirty);
      }
      doSort();
    }

    function doSort() {
      if (!sort) return;
      var mode = sort.value;
      var list = cards.slice().filter(function (c) { return !c.classList.contains('is-hidden'); });
      list.sort(function (a, b) {
        var pa = parseInt(a.getAttribute('data-price'), 10) || 0;
        var pb = parseInt(b.getAttribute('data-price'), 10) || 0;
        var ta = a.getAttribute('data-title') || '';
        var tb = b.getAttribute('data-title') || '';
        if (mode === 'price-asc') return pa - pb;
        if (mode === 'price-desc') return pb - pa;
        if (mode === 'title-asc') return ta.localeCompare(tb, 'sr');
        if (mode === 'title-desc') return tb.localeCompare(ta, 'sr');
        return (parseInt(a.getAttribute('data-index'), 10) || 0) - (parseInt(b.getAttribute('data-index'), 10) || 0);
      });
      list.forEach(function (c) { grid.appendChild(c); });
    }

    if (search) search.addEventListener('input', apply);
    if (sort) sort.addEventListener('change', apply);
    priceChips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        priceChips.forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        apply();
      });
    });
    if (stockChip) {
      stockChip.addEventListener('click', function () {
        stockChip.classList.toggle('is-active');
        apply();
      });
    }
    if (clearChip) {
      clearChip.addEventListener('click', function () {
        if (search) search.value = '';
        if (sort) sort.value = 'featured';
        if (stockChip) stockChip.classList.remove('is-active');
        priceChips.forEach(function (c) {
          c.classList.toggle('is-active', c.getAttribute('data-filter-price') === 'all');
        });
        apply();
      });
    }
    apply();
  }

  /* ---------------- Accordion (single-open per group) ---------------- */
  function initAccordions() {
    document.querySelectorAll('[data-accordion]').forEach(function (group) {
      var items = group.querySelectorAll('details');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  /* ---------------- Init ---------------- */
  function init() {
    document.querySelectorAll('[data-product-form]').forEach(initVariantPicker);
    initCollectionFilters();
    initAccordions();
    refreshDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
